import { configureSearchStore } from '@state';
import { initSearchQuerySync } from '@utils/search';
import React from 'react';
import { Provider } from 'react-redux';
import SearchDialog from './SearchDialog';
const store = configureSearchStore();
initSearchQuerySync(store);
const SearchApp = (props) => {
    return (React.createElement(Provider, { store: store },
        React.createElement(SearchDialog, Object.assign({}, props))));
};
export default SearchApp;
